import { FuelProgramTypeEnum } from './FuelProgramType';

export interface LoadFuelProgramData {
  fuelProgramType: FuelProgramTypeEnum;
  fuelRate: number;
}
